import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { PortalThemeProvider } from './context/PortalThemeContext';
import { RouteProvider } from './context/RouteContext';
import AppRoutes from './AppRoutes';
import LoggedInTopBar from './components/shared/LoggedInTopBar';
import { useRouteContext } from './context/RouteContext';
import ErrorBoundary from './components/shared/ErrorBoundary';

function AppLayout() {
  const { customer, logout } = useRouteContext();

  return (
    <div style={{ position: 'relative', minHeight: '100vh' }}>
      <div className="background-layer" />
      <div style={{ position: 'relative', zIndex: 1 }}>
        <LoggedInTopBar customer={customer} onLogout={logout} />
        <AppRoutes />
      </div>
    </div>
  );
}

export default function App() {
  return (
    <Router basename="/apps/brella">
      <ErrorBoundary>
        <PortalThemeProvider>
          <RouteProvider>
            <AppLayout />
          </RouteProvider>
        </PortalThemeProvider>
      </ErrorBoundary>
    </Router>
  );
}
